/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AzureDevOpsBuildLog {
    getFixupPrototypeFunction() { return AzureDevOpsBuildLog.fixupPrototype; }

    static newInstance(model: Partial<AzureDevOpsBuildLog>): AzureDevOpsBuildLog {
        let obj = Object.assign(new AzureDevOpsBuildLog(), model);
        AzureDevOpsBuildLog.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AzureDevOpsBuildLog>): AzureDevOpsBuildLog {
        if (!model) return null;
        return AzureDevOpsBuildLog.newInstance(<AzureDevOpsBuildLog> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AzureDevOpsBuildLog) {
        if (!obj) return;

        models.AzureDevOpsBuildLog.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AzureDevOpsBuildLog): boolean {
        Object.setPrototypeOf(obj, AzureDevOpsBuildLog.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.log_id === undefined) {
            this.log_id = 0;
        }
        if (typeof this.created_on === "string") {
            this.created_on = new Date(<string><any>this.created_on);
        }
        if (typeof this.last_changed_on === "string") {
            this.last_changed_on = new Date(<string><any>this.last_changed_on);
        }
    }

    /**
     * Build Log Id
     */
    log_id: number;

    /**
     * Build Log created datetime
     */
    created_on: Date;

    /**
     * Build Log latest update datetime
     */
    last_changed_on: Date;

    /**
     * List of raw log lines
     */
    log_lines: Array<string>;

}
